import { Flex, Text } from "@wayflyer/flyui";
import type { ReactNode } from "react";
import type { IntlShape } from "react-intl";
import { useIntl } from "react-intl";

import type { FormattedFundingApplicationScreen } from "../../../queries/funding-application/queries";
import { MESSAGES } from "../message-definitions";

const getMinEligibleRevenue = (revenueCurrency: string) => {
  return (
    {
      AUD: 12500,
      CAD: 12500,
      DKK: 72500,
      EUR: 10000,
      GBP: 7500,
      SEK: 100000,
      USD: 10000,
    }[revenueCurrency] || 0
  );
};

const getFormattedMinEligibleRevenue = (intl: IntlShape, revenueCurrency: string) => {
  const minRevenue = getMinEligibleRevenue(revenueCurrency);

  return intl.formatNumber(minRevenue, {
    style: "currency",
    currency: revenueCurrency,
    currencyDisplay: revenueCurrency === "USD" ? "narrowSymbol" : "symbol",
    maximumFractionDigits: 0,
  });
};

export const RevenueLetDown = ({
  eligibilityLink,
  fundingApplication,
}: {
  eligibilityLink: ReactNode;
  fundingApplication: FormattedFundingApplicationScreen;
}) => {
  const intl = useIntl();
  const revenueCurrency = fundingApplication.reportedRevenueCurrency || "USD";

  const minRevenueAmount = getFormattedMinEligibleRevenue(intl, revenueCurrency);
  return (
    <Flex direction="column" gap="4">
      <Text>
        {intl.formatMessage(MESSAGES.letDownSubHeading, {
          minRevenueAmount,
        })}
      </Text>
      <Text>{eligibilityLink}</Text>
    </Flex>
  );
};
